import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

export const CustomizeNeeds = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Flex
        mx="auto"
        maxW="990px"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ base: 'column', lg: 'row' }}
      >
        <Flex maxW="485px" flexDirection="column">
          <Heading mb={8} fontSize="4xl">
            {t('landing.customizeNeeds.title')}
          </Heading>
          <Trans
            i18nKey="landing.customizeNeeds.description"
            components={{
              text: <Text fontSize="md" />,
              quote: <Text fontSize="md" as="q" />,
            }}
          />
          <Text mt={8}>{t('landing.customizeNeeds.fullSupport')}</Text>
        </Flex>
        <video autoPlay loop muted playsInline width="600px">
          <source src="/videos/customize_needs.mp4" type="video/mp4" />
          <source src="/videos/customize_needs.webm" type="video/webm" />
        </video>
      </Flex>
    </Container>
  );
};
